<template>

    <div class="dd-m-quiz__loading">
        <div class="dd-m-quiz__loading__item dd-m-quiz__loading__item--1"></div>
        <div class="dd-m-quiz__loading__item dd-m-quiz__loading__item--2"></div>
    </div>

</template>
<script>
    export default {
        name: 'quiz-loading',
        data: () => {
            return {
                results: []
            }
        },
        mounted() {   
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/quiz/quiz-loading.vue